<template>
  <section class="audience-page">

    <!-- Header -->
    <header class="audience-header">
      <div>
        <h1>Your Creator Access</h1>
        <p>Stay connected, engaged, and rewarded.</p>
      </div>
    </header>

    <!-- KPI ROW -->
    <section class="kpis">
      <div class="kpi">
        <p>Profile Completion</p>
        <h2>{{ stats.profileCompletion }}%</h2>
      </div>

      <div class="kpi">
        <p>Following</p>
        <h2>{{ stats.followingCount }}</h2>
      </div>

      <div class="kpi">
        <p>Is Verified</p>
        <h2>{{ stats.connection }}</h2>
      </div>

      <!-- <div class="kpi">
        <p>Access Tier</p>
        <h2>{{ stats.tier }}</h2>
      </div> -->
    </section>

   

    <!-- Charts -->
    <section>
      <div class="card">
        <h3>Your Engagement Journey</h3>
        <div class="chart-placeholder" ref="engagementChart"></div>
      </div>

    </section>

    <!-- Activity Feed -->
    <!-- <section class="card">
      <h3 class="feed-title">Creator Updates</h3>

      <table class="audience-table">
        <thead>
          <tr>
            <th>Update</th>
            <th>Channel</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in feed" :key="item.id">
            <td>
              <strong>{{ item.bc_channel }}</strong>
              <div class="sub">{{ item.fcontent_text }}</div>
            </td>

            <td>{{ item.channel }}</td>

            <td>
              <span :class="['status-pill', item.status]">
                {{ item.status }}
              </span>
            </td>

            <td class="muted">{{ item.date }}</td>
          </tr>
        </tbody>
      </table>

      <div v-if="feed.length === 0" class="empty">
        No recent updates from your creator.
      </div>

    
    </section> -->
    <FanIntro
      :open="showDemoModal"
      @submit="saveDemo"
    />
  </section>
</template>

<script>
import { getBasicProfileApi } from "@/apis/fanapis";
import FanIntro from "@/comps/FanIntro.vue";
import ApexCharts from "apexcharts";
import { getFanDashboard,getEngagementChart } from "../apis/fanapis";

export default {
  name: "FanDashboardScreen",
  components:{
    FanIntro
  },
  data() {
    return {
      loading: false,
      showDemoModal: false,
      stats: {
        profileCompletion: "-",
        followingCount: 0,
        connection: "-"
      },
       charts: {
          engagement: null,
          activity: null
        },
      feed: [],
      user_id:""
    };
  },

  
  async mounted() {
    const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if(ldata!=null){
        this.user_id = ldata.user_id;
      }
    await this.loadDashboard();
    await this.loadCharts();
  },

  methods: {
     async saveDemo(data){
      console.log(data)

      // call API
      // await saveFanProfile(data)
       sessionStorage.setItem("isIntro34","done");
      this.showDemoModal=false
    },
    async loadCharts() {

        // ✅ Engagement Line
        const engagement = await getEngagementChart(this.user_id);

        if (engagement.status) {

          const options = {
            chart: { type: "line", height: 200 },
            colors: ["#0f172a"],
            series: [{ name: "Engagement", data: engagement.series }],
            xaxis: { categories: engagement.labels }
          };

          this.charts.engagement = new ApexCharts(
            this.$refs.engagementChart,
            options
          );

          this.charts.engagement.render();
        }
      },
    async loadDashboard() {
      try {

        this.loading = true;

        const res = await getFanDashboard(this.user_id);

        if (res.status) {
          this.stats = res.stats;
          this.feed = res.broadcasts;
        }

        const res1 = await getBasicProfileApi({
          user_id: this.user_id
        });

        if (res1.status) {
          sessionStorage.setItem("isIntro34","done");
          this.showDemoModal = false;
        }
        else{
           const isIntro34 = sessionStorage.getItem("isIntro34") || "";
           if(isIntro34.length <= 0){
            this.showDemoModal = true;
           }
        }

      } catch (e) {
        console.log("Dashboard error", e);
      } finally {
        this.loading = false;
      }
    },

  }
};
</script>

<style scoped>
.audience-page {
  max-width: 1440px;
  margin: auto;
  padding: 48px;
}

.audience-header h1 {
  font-size: 36px;
  font-weight: 800;
}

.audience-header p {
  color: #64748b;
  margin-top: 6px;
}

/* KPIs */
.kpis {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 32px 0;
}

.kpi {
  background: white;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.kpi p {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 700;
}

.kpi h2 {
  font-size: 24px;
  font-weight: 800;
}

/* Quick Actions */
.quick-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

/* Charts */
.charts {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

.chart-placeholder {
  height: 200px;
  background: #f8fafc;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-weight: 700;
}

/* Table */
.card {
  background: white;
  border-radius: 24px;
  padding: 32px;
  border: 1px solid #e5e7eb;
}

.feed-title {
  margin-bottom: 18px;
  font-size: 20px;
  font-weight: 800;
}

.audience-table {
  width: 100%;
  border-collapse: collapse;
}

.audience-table th,
.audience-table td {
  padding: 14px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.sub {
  font-size: 12px;
  color: #94a3b8;
}

.muted {
  font-size: 12px;
  color: #94a3b8;
}

/* Status */
.status-pill {
  font-size: 10px;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 800;
  text-transform: uppercase;
}

.status-pill.delivered {
  background: #ecfdf5;
  color: #047857;
}

.status-pill.active {
  background: #eff6ff;
  color: #1d4ed8;
}

.status-pill.new {
  background: #fef9c3;
  color: #854d0e;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.page-info {
  font-size: 13px;
  font-weight: 700;
  color: #475569;
}

.ghost-btn {
  background: #f1f5f9;
  padding: 8px 14px;
  border-radius: 12px;
  font-weight: 700;
  border: none;
  cursor: pointer;
}

.empty {
  padding: 24px;
  text-align: center;
  color: #64748b;
}

/* Mobile */
@media (max-width: 900px) {
  .kpis,
  .charts {
    grid-template-columns: 1fr;
  }

  .audience-page {
    padding: 24px;
  }
}
</style>